module.exports = __webpack_public_path__ + "img/image.74cba4fe.svg";